
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.9 47.88c6.02 0 10.9-4.88 10.9-10.9V22.23a9.56 9.56 0 008.89 4.29v-5.97c-4.63-.33-8.34-3.96-8.82-8.55h-5.13l-.05 25.05c0 3.07-2.71 5.49-5.79 5.49s-5.56-2.49-5.56-5.56a5.56 5.56 0 015.56-5.56c.23 0 .45.04.67.07v-5.37c-.22-.01-.45-.03-.67-.03-6.02-.01-10.9 4.87-10.9 10.89 0 6.02 4.88 10.9 10.9 10.9z","fill":"currentColor"}})])
          )
        }
      }
    